import styled from 'styled-components';

export const ModalBoxWrap = styled.div`
		position: absolute;
    top: 1.25rem;
    left: 50%;
    // right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
		z-index: 9;
		overflow: hidden;
    transform: translateX(-50%);
    white-space: nowrap;
		&.azimuthEdit{
		overflow: visible;
		}
		&.drawStrip{
			overflow: visible;

			.drawStrip-modalbox{
				overflow: visible;
			}
		}

		// &.flatten-shape-modal{
		// 	top: 3.85rem;
		// 	overflow: visible;
		// 	left: 54.5%;
		// 	transform: translateX(-54.5%);
		// 	> div {
		// 		border-radius: 8px;
		// 		padding: 2px 5px;
		// 	 }
		// }
		&.tree-editing-modal{
			overflow: inherit;
				> div{
					overflow: inherit; 
				}
			}
		
		@media (max-width: 540px){
		 top: 1.25rem;
		 left: 0;
		 right:0;
		 margin: 0 auto;
		 transform: translateX(0);
      justify-content: center;

		 &.flatten-shape-strip{
			 top: 4.25rem;
			 overflow: visible;
		 }
		}
		
		&.image-editor-strip{
			@media (max-width: 980px){
				top: 1.25rem;
				left: calc((100% - 320px) / 2);
				// transform: translateX(50%);
					justify-content: center;
			}
		}
		&.fullscreen{
		max-width: 100%;
		}
		&.editFacetWrap{
		> div{
					border: none;
					border-radius:none;
					overflow: hidden;
					padding: inherit;
					background: transparent;
					gap: .75rem;

					@media (max-width:980px){
					flex-direction: column;
					padding: 10px 10px;
					width: 100%;
					}
			}
					@media (max-width:980px){
					width: 100%;
					}
		 }
		&.obsPointsStrip{
			top: 4.1rem;

			@media (max-width: 768px){
				top: 4.35rem;
			}

			.obsPointsStrip-modalbox{
				padding: 2px 6px 2px 1rem;
				border-radius: 999px;
			}
		}
			
`;
export const ModalBox = styled.div`
		display: flex;
		align-items: center;
		pointer-events: all;
		border: 1px solid var(--modalBorderColor);
		border-radius: 91.4939px;
		overflow: hidden;
	
		padding: 0.275rem 0.813rem 0.275rem 1.125rem;
		background: var(--modalBgColor);

		.btn-drawfacet{
			background: transparent !important;
			margin-right: 10px;
			height: 32px;
			min-height:30px;
			padding-left:5px;
			position: relative;
			z-index: 2;

				&:before {
						content: '';
						position: absolute;
						left: -10px;
						height: 40px;
						width: 12px;
						background: var(--defaultBgColor);
						z-index: 1;	
				}

				&.active{
					&:before {
							// background: color(srgb 0.91 0.91 0.99);
					}
			}

			.buttonIcon{
				display: none;
			}
		}
		#delete-obstruction-mode, #undo, #redo{
			background: transparent !important;
			height: 30px;
			min-height:30px;
		}
		#delete-obstruction-mode{
			border-right:none;

			.buttonIcon{
				display: none;
			}
		}
		#add-panel{
			background: transparent !important;
			height: 32px;
			min-height:30px;
			padding:0 0.65rem 0 0.5rem;
			.buttonIcon{
				display:none;
			}
		}

`;

export const TreeEditingModalWrap = styled(ModalBoxWrap)<{ $fullscreen?: boolean }>`
	gap: 2px;
	align-items: stretch;
	overflow: inherit;
	max-width: ${({ $fullscreen }) => $fullscreen ? '100%' : 'none'};

	> div {
		overflow: inherit;
	}
`;

export const TreeEditingModalBox = styled(ModalBox)`
	overflow: inherit;
`;

export const Tree3DPill = styled.div<{ $active?: boolean; $disabled?: boolean }>`
	display: flex;
	align-items: center;
	align-self: stretch;
	pointer-events: all;
	border: 1px solid ${({ $active }) => $active ? 'var(--secondary)' : 'var(--borderLightColor)'};
	border-radius: 91.4939px;
	overflow: hidden;
	background: ${({ $active }) => $active ? 'var(--secondary)' : 'var(--defaultBgColor)'};
	transition: border-color 0.1s ease, box-shadow 0.15s ease, filter 0.1s ease;
	cursor: ${({ $disabled }) => $disabled ? 'not-allowed' : 'pointer'};

	&:hover {
		${({ $disabled }) => $disabled ? '' : 'box-shadow: 0 2px 8px rgba(0, 0, 0, 0.13);'}
		${({ $active, $disabled }) => $disabled
		? ''
		: $active
			? 'filter: brightness(0.96);'
			: 'border-color: var(--controlBorderColor); background: var(--hoverBgColor);'
}
	}

	&:active {
		${({ $disabled }) => $disabled ? '' : `
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
			transform: scale(0.98);
		`}
	}
	span, svg {
		opacity: ${({ $disabled }) => $disabled ? 0.75 : 1};
	}

	.in-pill {
		border: none !important;
		border-radius: 0 !important;
		padding: 0.2rem 0.6rem;
		min-height: auto;
		min-width: auto;
		font-weight: 600;
		font-size: 14px;
		box-shadow: none !important;
		svg {
			width: 22px;
			height: 22px;
		}
		&:hover,
		&:focus {
			border: none !important;
			box-shadow: none !important;
			background: transparent !important;
		}
		&.active {
			background: transparent !important;
		}
	}
`;

export const StripDiv = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 0;

	&.flatten-strip{
		position: absolute;
		bottom: -36px;
		left: 40px;
		background: var(--defaultBgColor);
		border-radius: 8px;
	}

	&.edit-obstructions-strip{
		svg{
			position: relative;
			top: 1px;
		}
	}
`;
export const LabelDiv = styled.div`
	font-size: 0.813rem;
	color: var(--subHeadingColor);
	transition-delay: 1s;
	font-family: Inter;
	font-weight:600;
	position:relative;
	border-right: 1px solid var(--borderLightColor);
	padding-right: .65rem;
	margin-right: 3.5px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: .5rem;
	min-height:27px;
`;

export const EditobstructionTabWrap = styled.div`
	   display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    background: transparent;
    border-radius: 999px;
    padding: 3px;
    gap: 0px;
		margin-left: 3px;
`;
